import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import StepperNavigationButtons from "../StepperNavigationButtons";
import urlParser from "js-video-url-parser/dist/jsVideoUrlParser.js?v=1.2";
import { _showToast } from "../../../../../toastHelper";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const InvitationDetails = forwardRef(function InvitationDetails(props, ref) {
  const [expiration, setExpiration] = useState(7);
  const [eventName, setEventName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [liveUrl, setLiveUrl] = useState("");
  const [errors, setErrors] = useState({});
  const [imageKey, setImageKey] = useState("");
  const thumbnailRef = useRef();

  useEffect(() => {
    resetData();
    if (props.data) {
      setEventDate(props.data.eventDate);
      setEventName(props.data.title);
      setExpiration(props.data.expiration);
      setLiveUrl(props.data.liveUrl);
      setImageKey(props.data.imageKey);
      thumbnailRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
      thumbnailRef?.current?.setFileContent(props.data.imageFile);
    }
  }, [props.data]);

  const resetData = () => {
    setEventDate("");
    setEventName("");
    setExpiration(7);
    setLiveUrl("");
    thumbnailRef?.current?.setThumbnail(null);
    thumbnailRef?.current?.setFileContent(null);
  }

  const validate = () => {
    const errors = {};

    if (!eventName || (eventName && eventName.trim() == "")) {
      errors.eventName = "Invitation title is required";
    }

    if (!eventDate || (eventDate && eventDate.trim() == "")) {
      errors.eventDate = "Date of event is required";
    }

    if (liveUrl && liveUrl != "") {
      let parsedData = urlParser.parse(liveUrl);
      if (!(parsedData && parsedData?.id && parsedData.id != "")) {
        errors.liveUrl = "Invalid live url";
      }
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  }

  const getData = () => {
    return {
      title: eventName,
      eventDate: eventDate,
      image: thumbnailRef?.current?.getThumbnail() ?? null,
      imageFile: thumbnailRef?.current?.getImageFile() ?? null,
      expiration: expiration ?? 7,
      liveUrl: liveUrl,
      imageKey: imageKey
    };
  }

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate
  }));

  return (
    <>
      <div className="content" style={{ display: "block", visibility: "visible" }}>
        <div className="content-header mb-3">
          <div className="sec-titler">
            <h2 className="text-primary">Invitation Details</h2>
            <div className="title-shape"></div>
          </div>
        </div>
        <form>
          <div className="row mt-4">
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="invitationTitle">
                Invitation Title
              </label>
              <input
                type="text"
                id="invitationTitle"
                name="invitationTitle"
                className={`form-control ${errors.eventName ? "is-invalid" : ""}`}
                placeholder="Enter Invitation Title"
                value={eventName}
                onChange={(e) => setEventName(e.target.value)}
              />
              {errors.eventName && (
                <div className="invalid-feedback">
                  {errors.eventName}
                </div>
              )}
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="dateofevent">
                Date of event
              </label>
              <input type="date"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.eventDate ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please select date of event"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
              />
              {errors.eventDate && (
                <div className="invalid-feedback">
                  {errors.eventDate}
                </div>
              )}
            </div>
            <div className="col-sm-6 mt-3" >
              <label className="form-label" htmlFor="liveurl">
                Live Url
              </label>
              <input
                type="text"
                id="liveurl"
                name="liveurl"
                className={`form-control ${errors.liveUrl ? "is-invalid" : ""}`}
                placeholder="Enter Live Url"
                value={liveUrl}
                onChange={(e) => setLiveUrl(e.target.value)}
              />
              {errors.liveUrl && (
                <div className="invalid-feedback">
                  {errors.liveUrl}
                </div>
              )}
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label required" htmlFor="dateofevent">
                Auto Delete After How Many Days (From Last Date of Events)
              </label>
              <select
                id="expiration"
                name="expiration"
                className="form-select"
                value={expiration}
                onChange={(e) => setExpiration(e.target.value)}>
                <option value={7}>
                  After 1 Week
                </option>
                <option value={15}>
                  After 15 Days
                </option>
                <option value={30}>
                  After 1 Month
                </option>
                <option value={60}>
                  After 2 Months
                </option>
                <option value={-1}>
                  Never Expire
                </option>
              </select>
              {errors.eventDate && (
                <div className="invalid-feedback">
                  {errors.eventDate}
                </div>
              )}
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-sm-6">
              <label className="form-label" htmlFor="eventThumbnail">
                Invitation Thumbnail <small className="text-gray">(Max Allowable File Size: 1MB,Dimensions: 750px x 750px)</small>
              </label>
              <ImageBrowse elementId="eventThumbnail" ref={thumbnailRef} imageType="profile" 
              imageKey={imageKey} setImageKey={setImageKey} imageDelete={props.imageDelete} />
            </div>
          </div>
          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
        </form>
      </div>
    </>
  );
});

export default InvitationDetails;